import { useEffect } from "react";
import { Outlet, useLocation } from "react-router-dom";
import { OrganizationsIcon, PolicyIcon } from "~/icons";
import { useCanGetPoliciesForAnalytics } from "~/lib/iam/actions/mondoo/policy/ExtendedHub/GetPoliciesForAnalytics";
import { useAppNavDrawer } from "~/providers/app-nav-drawer";
import { useFeatureFlags } from "~/providers/FeatureFlagsProvider";

export function PlatformLayout() {
  const { setTree } = useAppNavDrawer();
  const { pathname } = useLocation();
  const canGetPoliciesForAnalytics = useCanGetPoliciesForAnalytics();
  const { isFeatureEnabled } = useFeatureFlags();

  const platformPolicyMgmtEnabled = isFeatureEnabled(
    "Platform Policy Management",
  );

  useEffect(() => {
    setTree(
      [
        {
          text: "Organizations",
          icon: <OrganizationsIcon />,
          link: {
            to: `/dashboard`,
          },
          selected: ["/dashboard", "/organizations"].some((path) =>
            pathname.startsWith(path),
          ),
        },
        canGetPoliciesForAnalytics && platformPolicyMgmtEnabled
          ? {
              text: "Policies",
              icon: <PolicyIcon />,
              link: {
                to: `/policies`,
              },
            }
          : null,
      ].flatMap((item) => item ?? []),
    );
    return () => setTree([]);
  }, [canGetPoliciesForAnalytics, platformPolicyMgmtEnabled, pathname]);

  return <Outlet />;
}
